function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.019 13.631a8.1 8.1 0 01-3-6 7.913 7.913 0 012.486-5.546.735.735 0 011.029 0 7.917 7.917 0 012.485 5.546 8.1 8.1 0 01-3 6z",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.94 6.581A8.555 8.555 0 0119.8 5.1a.748.748 0 01.747.744 7.906 7.906 0 01-2.164 5.663 8.1 8.1 0 01-6.364 2.121M9.1 6.592A8.484 8.484 0 004.2 5.1a.749.749 0 00-.749.744 7.906 7.906 0 002.161 5.666 8.182 8.182 0 006.407 2.121m7.481.994c0 2.071-3.358 3.75-7.5 3.75s-7.5-1.675-7.5-3.75",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.31 11.622a5.437 5.437 0 01.938 3c0 4.142-5.037 7.5-11.25 7.5S.748 18.767.748 14.625a5.439 5.439 0 01.936-3",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

function SvgSpaLotus1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor"
  }, props), _ref, _ref2, _ref3);
}

export default SvgSpaLotus1;